// Kullanıcı adı aktif değisle route'a geçişi engeller
export default function requiresActiveSender(store, next) {
  if (!store.state.user.sender_active) {
    next('/');
  } else {
    next();
  }
}
